import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const AgentUser = () => {
  const context = useContext(CompetitionContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const { get } = useApi();
  const { error } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  // const [removeLoading, setRemoveLoading] = useState(false);
  const [checked, setChcked] = useState([]);
  const [parseParams, setParseParams] = useState({});
  const [filterModal, setFilterModal] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await competition();
    };

    getData();
  }, [id, search]);

  const competition = async () => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        context.competition = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  const competitionFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/competition${filter}`);
    setFilterModal(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title={`لیست عوامل اجرایی مسابقه ${context.competition?.title}`}
          showBackBtn={true}
          showCreateBtn={false}
          showExcelBtn={true}
          showFilterBtn={true}
          backPath={`/competition/competition}`}
        />
        <div className='row mt-2 mb-3'>
          <div className='col-12 col-md-4'>
            <div className='d-flex flex-row justify-content-start'>
              <button
                onClick={() => {
                  if (checked.length === 0) {
                    return error(
                      'برای چاپ آی دی کارت لطفا ابتدا سطر های مورد نظر را انتخاب کنید.',
                    );
                  }
                  return navigate(
                    `/id-card/competition/${context.competition?.id}/agent`,
                    {
                      state: {
                        users: checked,
                      },
                    },
                  );
                }}
                className='btn bg-purple p-2 text-white f-13'
              >
                چاپ آی دی کارت
              </button>
            </div>
          </div>
        </div>
        <Datatable
          data={context.competition?.agents}
          editUrl='#'
          meta={{}}
          checkedField='user_id'
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          disableAllActions={true}
          selectRows={true}
          setRowId={setChcked}
          rowId={checked}
          basePagePath={`/competition`}
          columns={['تصویر', 'نام', 'نام خانوادگی', 'کد ملی', 'استان', 'سمت']}
          rows={[
            { name: 'personnel_image', type: 'image' },
            { name: 'name', type: 'string' },
            { name: 'last_name', type: 'string' },
            { name: 'national_card_id', type: 'string' },
            {
              name: 'province_living.name',
              type: 'relation',
              relType: 'string',
            },
            { name: 'agent_side', type: 'string' },
          ]}
        />
      </Master>
    </>
  );
};
export default AgentUser;
